import { Card, Divider, Box, Stack } from '@mui/joy';
import { FormInput } from '@/components/forms/FormInput';
import { RemoveFormElementButton } from '@/components/RemoveFormElementButton';

export function GroupCard({ path, placeholder, removable, onRemove, children }) {
  return (
    <Card variant="outlined" sx={{ pr: 1 }}>
      <Box sx={{ ml: -1, mt: -1, mb: 0 }}>
        <Stack direction="row" spacing={1}>
          <FormInput name={`${path}.name`} variant="plain" placeholder={placeholder} sx={{ flexGrow: 1 }} />
          {removable && <RemoveFormElementButton onClick={onRemove} />}
        </Stack>
        <Divider sx={{ mx: -1, mt: 1 }} />
      </Box>
      {children}
    </Card>
  )
}
